import Vue from "vue";
import VueRouter from "vue-router";
import Error from "@views/404.vue";
import Login from "@views/main/login.vue";
import Main  from '@views/main/Main.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    meta: {
      title: '404页面'
    },
    component: Error
  },
  {
    path: "/",
    name: "Login",
    meta: {
      title: '后台系统登录'
    },
    component: Login
  },
  {
      path: "/loginOut",
      name: "loginOut",
      meta: {
          title: '后台系统登录'
      },
      component: Login
  },
  {
    path: '/main',
    name: 'Main',
    meta: {
      title: '电商平台',
      login: true
    },
    component: Main,
    children: [
      
      /*系统管理*/
      {
        path: '/sys/user',
        name: 'SysUser',
        meta: {
          title: '用户管理',
          login: true
        },
        component: () => import("@views/sys/user/list.vue")
      },
      /*系统管理*/
      {
        path: '/sys/user/list',
        name: 'sysUserList',
        component: () => import("@views/sys/user/list.vue"),
        meta: {
          title: '用户管理',
          login: true
        }
      },
      {
        path: '/sys/user/edit',
        name: 'sysUserEdit',
        meta: {
          title: '用户编辑',
          login: true
        },
        component: () => import('@views/sys/user/editMultUpload.vue')
      },
      {
        path: '/sys/func',
        name: 'sysFunc',
        redirect: '/sys/func/list',
        meta: {
          title: '功能管理',
          login: true,
        },
        component: () => import('@views/sys/func/func.vue'),
        children:[
          {
            path: '/sys/func/list',
            name: 'sysFuncList',
            meta: {
              title: '功能管理',
              login: true
            },
            component: resolve => { require(['@views/sys/func/list.vue'], resolve) }
          },
          {
            path: '/sys/func/edit',
            name: 'sysFuncEdit',
            component: resolve => { require(['@views/sys/func/edit.vue'], resolve) },
            meta: {
              title: '功能编辑',
              login: true
            }
          },
        ]
      },
      {
        path: '/sys/role/list',
        name: 'sysRoleList',
        meta: {
          title: '角色管理',
          login: true
        },
        component: resolve => { require(['@views/sys/role/list.vue'], resolve) }
      },
      {
        path: '/sys/role/edit/',
        name: 'sysRoleEdit',
        meta: {
          title: '角色编辑',
          login: true
        },
        component: () => import("@views/sys/role/edit.vue")
      },
      /*基础管理*/
      {
        path: '/sys/enum/list',
        name: 'sysEnumList',
        meta: {
          title: '枚举数据管理',
          login: true
        },
        component: () => import("@views/sys/enum/enum-list.vue")
      },
      {
        path: '/sys/enum/edit',
        name: 'sysEnumEdit',
        meta: {
          title: '枚举数据编辑',
          login: true
        },
        component: () => import("@views/sys/enum/enum-edit.vue")
      },
      {
        path:'/sys/icon/icon',
        name:'sysIcon',
        meta:{
          title: '图标',
          login: true
        },
        component: () => import("@views/sys/icon/icon.vue")
      },
      {
        path:'/sys/exception/list',
        name:'sysExceptionList',
        meta:{
          title: '异常列表',
          login: true
        },
        component: () => import("@views/sys/exception/list.vue")
      },
      {
        path:'/sys/file/list',
        name:'sysFileList',
        meta:{
            title: '文件管理',
            login: true
        },
        component: () => import("@views/sys/file/list.vue")
      },
        /*图片分类*/
        {
            path:'/sys/image/category/frame',
            name:'sysImageCategoryFrame',
            redirect: '/sys/image/category/list',
            component:resolve=>{require(['@views/sys/image/category/frame.vue'], resolve)},
            meta:{
                title: '图片分类树表',
                login: true
            },
            children:[
                {
                    path: '/sys/image/category/list',
                    name: 'imageCategoryList',
                    component: resolve => { require(['@views/sys/image/category/list'], resolve) },
                    meta: {
                        title: '图片分类',
                        login: true
                    }
                },
                {
                    path: '/sys/image/category/edit',
                    name: 'imageCategoryEdit',
                    component: resolve => { require(['@views/sys/image/category/edit.vue'], resolve) },
                    meta: {
                        title: '图片分类编辑',
                        login: true
                    }
                },
            ]
        },
        /*图片分类*/
        {
            path:'/sys/image/frame',
            name:'sysImageFrame',
            redirect: '/sys/image/image',
            component:resolve=>{require(['@views/sys/image/frame.vue'], resolve)},
            meta:{
                title: '图片管理',
                login: true
            },
            children:[
                {
                    path: '/sys/image/image',
                    name: 'imageList',
                    component: resolve => { require(['@views/sys/image/imageItem'], resolve) },
                    meta: {
                        title: '图片',
                        login: true
                    }
                },

            ]
        },
        /**
         * 商品
         */
        {
            path: '/eb/store/product/list',
            name: 'storeProductList',
            component: resolve => { require(['@views/eb/store/product/list'], resolve) },
            meta: {
                title: '商品管理',
                login: true
            }
        },
        {
            path: '/eb/store/product/edit',
            name: 'storeProductEdit',
            component: resolve => { require(['@views/eb/store/product/newTabsEdit.vue'], resolve) },
            meta: {
                title: '商品管理编辑',
                login: true
            }
        },
        {
            path: '/eb/store/product/attr',
            name: 'storeProductAttr',
            component: resolve => { require(['@views/eb/store/product/attr.vue'], resolve) },
            meta: {
                title: '商品属性配置',
                login: true
            }
        },
        /**团购 */
        {
            path: '/eb/diy',
            name: 'EbDiy',
            meta: {
              title: '客户定制',
              login: true
            },
            component: () => import("@views/eb/diy/list.vue")
          },
        /*商品分类*/
        {
            path:'/eb/store/category/frame',
            name:'storeCategoryFrame',
            redirect: '/eb/store/category/list',
            component:resolve=>{require(['@views/eb/store/category/frame.vue'], resolve)},
            meta:{
                title: '商品分类树表',
                login: true
            },
            children:[
                {
                    path: '/eb/store/category/list',
                    name: 'storeCategoryList',
                    component: resolve => { require(['@views/eb/store/category/list'], resolve) },
                    meta: {
                        title: '商品分类',
                        login: true
                    }
                },
                {
                    path: '/eb/store/category/edit',
                    name: 'storeCategoryEdit',
                    component: resolve => { require(['@views/eb/store/category/edit.vue'], resolve) },
                    meta: {
                        title: '商品分类编辑',
                        login: true
                    }
                },
            ]
        },
        //商品特惠
        {
            path:'/eb/store/product/discount/list',
            name:'ebDiscountList',
            meta:{
                title: '限时特惠活动',
                login: true
            },
            component: () => import("@views/eb/discount/list.vue")
        },
        {
            path:'/eb/store/product/discount/edit',
            name:'ebDiscountEdit',
            meta:{
                title: '限时特惠活动修改',
                login: true
            },
            component: () => import("@views/eb/discount/edit.vue")
        },
        {
            path:'/eb/store/product/discount/productAdd',
            name:'ebDiscountProductAdd',
            meta:{
                title: '添加特惠商品',
                login: true
            },
            component: () => import("@views/eb/discount/productAdd.vue")
        },
        /**
         * 物流
         */
        {
            path:'/eb/express/list',
            name:'expressList',
            component: () => import("@views/eb/express/list.vue"),
            meta:{
                title: '物流列表页面',
                login: true
            },
        },
        {
            path:'/eb/express/edit',
            name:'expressEdit',
            component: () => import("@views/eb/express/edit.vue"),
            meta:{
                title: '物流列表编辑',
                login: true
            },
        },
        /**
         * 订单
         */
        {
            path:'/eb/order/list',
            name:'ebOrderList',
            meta:{
                title: '订单列表页面',
                login: true
            },
            component: () => import("@views/eb/order/list.vue")
        },
        {
            path:'/eb/order/orderDesc',
            name:'ebOrderDesc',
            meta:{
                title: '订单详情页面',
                login: true
            },
            component: () => import("@views/eb/order/orderDesc.vue")
        },
        {
            path:'/eb/order/send/list',
            name:'ebOrderSendList',
            meta:{
                title: '发货列表页面',
                login: true
            },
            component: () => import("@views/eb/order/send/list.vue")
        },

        {
            path:'/eb/order/send/info',
            name:'ebOrderSendInfo',
            meta:{
                title: '发货详情',
                login: true
            },
            component: () => import("@views/eb/order/send/info.vue")
        },

        {
            path:'/eb/order/send/table',
            name:'ebOrderSendTable',
            meta:{
                title: '物流列表页面',
                login: true
            },
            component: () => import("@views/eb/order/send/table.vue")
        },
        {
            path:'/eb/order/send/edit',
            name:'ebOrderSendEdit',
            meta:{
                title: '物流编辑页面',
                login: true
            },
            component: () => import("@views/eb/order/send/edit.vue")
        },
       
        /**
         * 与微信交互的管理
         */
        {
            path:'/eb/pay/record/list',
            name:'payRecordList',
            meta:{
                title: '微信支付管理页面',
                login: true
            },
            component: () => import("@views/eb/pay/record/list.vue")
        },
        /**
         * 会员
         */
        {
            path:'/eb/user/list',
            name:'ebUserList',
            meta:{
                title: '会员管理页面',
                login: true
            },
            component: () => import("@views/eb/user/list.vue")
        },
        {
            path:'/eb/user/edit',
            name:'ebUserEdit',
            meta:{
                title: '会员管理编辑',
                login: true
            },
            component: () => import("@views/eb/user/edit.vue")
        },
        {
            path:'/eb/user/level/list',
            name:'ebUserLevelList',
            meta:{
                title: '会员等级',
                login: true
            },
            component: () => import("@views/eb/user/level/list.vue")
        },
        {
            path:'/eb/user/level/edit',
            name:'ebUserLevelEdit',
            meta:{
                title: '会员等级编辑',
                login: true
            },
            component: () => import("@views/eb/user/level/edit.vue")
        },
        /**
         * 售后
         */
        {
            path:'/eb/order/aftersale/list',
            name:'ebOrderAftersaleList',
            meta:{
                title: '售后列表页面',
                login: true
            },
            component: () => import("@views/eb/order/aftersale/list.vue")
        },
        {
            path:'/eb/order/aftersale/auditProcess',
            name:'auditProcess',
            meta:{
                title: '处理售后申请',
                login: true
            },
            component: () => import("@views/eb/order/aftersale/auditProcess.vue")
        },
        {
            path:'/eb/order/aftersale/task/list',
            name:'ebOrderAftersaleTaskList',
            meta:{
                title: '售后任务列表',
                login: true
            },
            component: () => import("@views/eb/order/aftersale/task/list.vue")
        },
      
        /**
         * 推广
         */
        {
            path:'/eb/commission/record/list',
            name:'commissionRecordList',
            meta:{
                title: '佣金记录',
                login: true
            },
            component: () => import("@views/eb/member/commission/record/list.vue")
        },
        {
            path:'/eb/withdrawal/record/list',
            name:'withdrawalRecordList',
            meta:{
                title: '提现记录',
                login: true
            },
            component: () => import("@views/eb/member/withdrawal/record/list.vue")
        },
        /**
         * 优惠券
         */
        {
            path:'/member/coupon/list',
            name:'couponList',
            meta:{
                title: '优惠券列表',
                login: true
            },
            component: () => import("@views/eb/member/coupon/list.vue")
        },
        {
            path:'/member/coupon/edit',
            name:'couponEdit',
            meta:{
                title: '优惠券列表',
                login: true
            },
            component: () => import("@views/eb/member/coupon/edit.vue")
        },
        {
            path:'/eb/member/coupon/record/list',
            name:'couponRecordList',
            meta:{
                title: '优惠券列表',
                login: true
            },
            component: () => import("@views/eb/member/coupon/record/list.vue")
        },

        /**
         * 悦旅卡
         */
        {
            path:'/eb/card/types/list',
            name:'cardTypesList',
            meta:{
                title: '卡种类列表',
                login: true
            },
            component: () => import("@views/eb/card/types/list.vue")
        },
        {
            path:'/eb/card/types/edit',
            name:'cardTypesEdit',
            meta:{
                title: '卡种类修改',
                login: true
            },
            component: () => import("@views/eb/card/types/edit.vue")
        },
        {
            path:'/eb/entity/card/batch/product/list',
            name:'entityCardBatchProductList',
            meta:{
                title: '实体卡制作列表',
                login: true
            },
            component: () => import("@views/eb/entity/card/batch/product/list.vue")
        },
        {
            path:'/eb/entity/card/batch/product/edit',
            name:'entityCardBatchProductEdit',
            meta:{
                title: '实体卡制作编辑',
                login: true
            },
            component: () => import("@views/eb/entity/card/batch/product/edit.vue")
        },
        /**
         * quartz
         */
        {
            path:'/quartz/entity/list',
            name:'quartzEntityList',
            meta:{
                title: '任务列表',
                login: true
            },
            component: () => import("@views/quartz/list.vue")
        },
        {
            path:'/quartz/entity/edit',
            name:'quartzEntityEdit',
            meta:{
                title: '任务修改',
                login: true
            },
            component: () => import("@views/quartz/edit.vue")
        },
        /*文章分类*/
        {
            path:'/eb/article/category/frame',
            name:'articleCategoryFrame',
            redirect: '/eb/article/category/list',
            component:resolve=>{require(['@views/eb/article/category/frame.vue'], resolve)},
            meta:{
                title: '文章分类树表',
                login: true
            },
            children:[
                {
                    path: '/eb/article/category/list',
                    name: 'articleCategoryList',
                    component: resolve => { require(['@views/eb/article/category/list'], resolve) },
                    meta: {
                        title: '文章分类',
                        login: true
                    }
                },
                {
                    path: '/eb/article/category/edit',
                    name: 'articleCategoryEdit',
                    component: resolve => { require(['@views/eb/article/category/edit.vue'], resolve) },
                    meta: {
                        title: '文章分类编辑',
                        login: true
                    }
                },
            ]
        },
        {
            path: '/eb/article/list',
            name: 'articleList',
            component: resolve => { require(['@views/eb/article/list'], resolve) },
            meta: {
                title: '文章管理',
                login: true
            }
        },
        {
            path: '/eb/article/edit',
            name: 'articleEdit',
            component: resolve => { require(['@views/eb/article/edit'], resolve) },
            meta: {
                title: '文章编辑',
                login: true
            }
        },
        /*crmeb管理--维护*/
        {
            path:'/eb/system/group/list',
            name:'systemGroupList',
            component:resolve=>{require(['@views/eb/system/group/list.vue'], resolve)},
            meta:{
                title: '组合数据列表',
                login: true
            }
        },
        {
            path:'/eb/system/group/edit',
            name:'systemGroupEdit',
            component:resolve=>{require(['@views/eb/system/group/edit.vue'], resolve)},
            meta:{
                title: '组合数据编辑',
                login: true
            }
        },

        

       

        /*配置分类*/
        {
            path:'/eb/system/config/tab/list',
            name:'systemConfigTabList',
            component:resolve=>{require(['@views/eb/system/config/tab/list.vue'], resolve)},
            meta:{
                title: '配置分类列表',
                login: true
            }
        },
        {
            path:'/eb/system/config/tab/edit',
            name:'systemConfigTabEdit',
            component:resolve=>{require(['@views/eb/system/config/tab/edit.vue'], resolve)},
            meta:{
                title: '配置分类编辑',
                login: true
            }
        },
        {
            path:'/eb/system/config/create',
            name:'systemConfigTabCreate',
            component:resolve=>{require(['@views/eb/system/config/configCreate.vue'], resolve)},
            meta:{
                title: '配置添加',
                login: true
            }
        },
        {
            path:'/eb/system/config/index',
            name:'systemConfigTabIndex',
            component:resolve=>{require(['@views/eb/system/config/index.vue'], resolve)},
            meta:{
                title: '系统设置',
                login: true
            }
        },
        {
            path:'/eb/system/group/data/list',
            name:'systemGroupDataList',
            component:resolve=>{require(['@views/eb/system/group/data/list.vue'], resolve)},
            meta:{
                title: '组合数据列表',
                login: true
            }
        },
        {
            path:'/eb/system/group/data/edit',
            name:'systemGroupDataEdit',
            component:resolve=>{require(['@views/eb/system/group/data/edit.vue'], resolve)},
            meta:{
                title: '组合数据列表编辑',
                login: true
            }
        },
        {
            path:'/eb/system/group/data/index',
            name:'systemGroupDataIndex',
            component:resolve=>{require(['@views/eb/system/group/data/index.vue'], resolve)},
            meta:{
                title: '首页数据',
                login: true
            }
        },
        {
            path:'/sys/test/upload',
            name:'sysTestUpload',
            meta:{
                title: '文件上传',
                login: true
            },
            component: () => import("@views/sys/test/upload.vue")
        },
        {
            path:'/sys/test/ueditor',
            name:'sysTestUeditor',
            meta:{
                title: '编辑器',
                login: true
            },
            component: () => import("@views/sys/test/ueditor.vue")
        },
        {
            path:'/sys/test/uploadDemo',
            name:'sysUploadDemo',
            meta:{
                title: '文件上传',
                login: true
            },
            component: () => import("@views/sys/test/mult-uploader.vue")
        },
        {
            path:'/sys/test/editor',
            name:'sysTestEditor',
            meta:{
                title: '百度编辑器',
                login: true
            },
            component: () => import("@views/sys/test/editor.vue")
        }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
